import api from './axiosInstance';

function getParentId() {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    return user?.parent_id ?? user?.id;
  } catch { return null; }
}

export const getSubUsersApi = () =>
  api.get('/get-sub-users', { params: { id: getParentId() } });

export const getFarmsForScopeApi = () =>
  api.get('/get-farms-for-scope', { params: { parent_id: getParentId() } });

export const getPlotsForScopeApi = (farmId) =>
  api.get('/get-plots-for-scope', { params: { parent_id: getParentId(), farm_id: farmId } });

export const getCropsForScopeApi = (plotId) =>
  api.get('/get-crops-for-scope', { params: { parent_id: getParentId(), plot_id: plotId } });

export const createSubUserApi = (data) =>
  api.post('/create-sub-user', { parent_id: getParentId(), ...data });

export const editSubUserApi = (data) =>
  api.post('/edit-sub-user', { parent_id: getParentId(), ...data });

export const removeSubUserApi = ({ user_id, mobile }) =>
  api.post('/remove-from-parent', {
    user_id,
    parent_id: getParentId(),
    mobile,
    removed_parent: true,
  });
